<template>
    <div>

    </div>
</template>

<script>
    import axios from 'axios'
    import '@/app-assets/js/scripts/extensions/ext-component-block-ui.js'
    export default {
        mounted(){
            let docusignToken = this.$route.fullPath
            const pattern = new RegExp(/code=([^&]*)/, 'g')

            this.$apiCall.put(`/v1/docusign/needsConsent/consentFlag=true`)
            .then(res => {
                console.log(res)
                this.$store.dispatch('docusignToken/setToken', pattern.exec(docusignToken)[1])
            })
            .catch(err => {
                console.log(err)
                this.$store.dispatch('docusignToken/setToken', pattern.exec(docusignToken)[1])
            })
        }
    }
</script>

